import { httpClient } from 'shared/services/http/httpClient';
import {
  payLoadAddDiscount,
  discountBuilder,
  DiscountModel
} from '../models/discountsModel';
import { DiscountById, PayLoadEditDiscount } from '../models/discountModel';

export const discountsService = () => {
  const getDiscounts = async (
    page: number | null,
    page_size: number | null,
    search: string | null,
    sort: string  | null,
    sort_dir: string | null,
    finished: string | null
  ): Promise<DiscountModel> => {
    const res = await httpClient.get('general-discounts', {
      params: {
        page,
        page_size,
        search,
        sort,
        sort_dir,
        finished
      }
    });
    return res;
  };

  const addDiscount = async (values: payLoadAddDiscount) => {
    const res = await httpClient.post(
      'general-discounts',
      discountBuilder.toBackEnd(values)
    );
    return res;
  };

  const getDiscountById = async (id: string): Promise<DiscountById> => {
    const res = await httpClient.get(`general-discounts/${id}`);
    return res;
  };

  const editDiscount = async (values: PayLoadEditDiscount) => {
    const { id, ...rest } = values;
    const res = await httpClient.put(`general-discounts/${id}`, discountBuilder.toBackEnd(rest));
    return res;
  };

  const deleteDiscount = async (id: number) => {
    const res = await httpClient.delete(`general-discounts/${id}`);
    return res;
  };

  return { getDiscounts, addDiscount, getDiscountById, editDiscount, deleteDiscount };
};
